module.exports = __webpack_public_path__ + "static/media/strip-tablet-desk.ebc9c715.png";